import { db } from "../../firebase/firebaseConfig";

import {

    collection,

    getDocs

} from "firebase/firestore";

/*
========================================================

YUTAKE
Motor Universal de Evaluación
Versión 2.0

El motor únicamente resuelve Estados Académicos.

No almacena información.
No consulta Firebase.
No modifica datos.
No toma decisiones pedagógicas.

========================================================
*/

/*======================================================
CONSTANTES
======================================================*/

const PESOS_INDICE = Object.freeze({

    precision: 0.40,

    dominio: 0.25,

    persistencia: 0.20,

    velocidad: 0.10,

    cobertura: 0.05

});

const ESCALAS_EXAMEN = Object.freeze({

    UNAL: {

        minimo: 300,

        maximo: 1000

    },

    ICFES: {

        minimo: 0,

        maximo: 500

    },

    UDEA: {

        minimo: 0,

        maximo: 100

    }

});

const NIVEL_MAXIMO = 5;

/*======================================================
ESTADO ACADÉMICO
======================================================*/

const crearEstadoAcademico = ({

    tipo,

    id,

    hijos = [],

    variables = {},

    indice = 0,

    nivel = 0,

    suficiente = false,

    diagnostico = null,

    metadata = {}

}) => ({

    tipo,

    id,

    hijos,

    variables,

    indice,

    nivel,

    suficiente,

    diagnostico,

    metadata

});

/*======================================================
NODO ACADÉMICO
======================================================*/

const crearNodoAcademico = ({

    tipo,

    id,

    ponderador = 1,

    configuracion = {},

    hijos = []

}) => ({

    tipo,

    id,

    ponderador,

    configuracion,

    hijos

});

/*======================================================
CONTEXTO DE RESOLUCIÓN
======================================================*/

const crearContextoResolucion = ({

    nodo,

    evidencias = [],

    fechaEvaluacion = new Date(),

    disponibilidad = {},

    configuracionMotor = {}

}) => ({

    nodo,

    evidencias,

    fechaEvaluacion,

    disponibilidad,

    configuracionMotor

});


/*======================================================
RECUPERAR EVIDENCIAS
======================================================*/

const recuperarEvidencias = (contexto) => {

    return {

        ...contexto,

        configuracion:

            contexto.nodo.configuracion ?? {}

    };

};

const validarEstadoInicial = (contexto) => {

    contexto.estadoInicial =

        contexto.evidencias.length === 0;

    return contexto;

};
/*======================================================
VARIABLES ACADÉMICAS
======================================================*/

const calcularPrecision = (contexto) => {

    const total = contexto.evidencias.length;

    if (total === 0) {

        return 0;

    }

    const correctas = contexto.evidencias.filter(

        evidencia => evidencia.resultado === true

    ).length;

    return correctas / total;

};

const calcularDominio = (contexto) => {

    const total = contexto.evidencias.length;

    if (total === 0) {

        return 0;

    }

    let pesoObtenido = 0;

    let pesoTotal = 0;

    contexto.evidencias.forEach(evidencia => {

        const peso = Number(evidencia.dificultad ?? 1);

        pesoTotal += peso;

        if (evidencia.resultado === true) {

            pesoObtenido += peso;

        }

    });

    return pesoTotal === 0

        ? 0

        : pesoObtenido / pesoTotal;

};

const calcularPersistencia = () => {

    // V1
    return 1;

};

const calcularVelocidad = () => {

    // V1
    return 1;

};

const calcularCobertura = () => {

    // V1
    return 1;

};

const calcularConfianza = (contexto) => {

    const total = contexto.evidencias.length;

    return Math.min(1, total / 20);

};

const resolverVariables = (contexto) => {

    const precision = calcularPrecision(contexto);
    const dominio = calcularDominio(contexto);
    const persistencia = calcularPersistencia(contexto);
    const velocidad = calcularVelocidad(contexto);
    const cobertura = calcularCobertura(contexto);
    const confianza = calcularConfianza(contexto);

    console.log("VARIABLES CALCULADAS");

    console.table({
        precision,
        dominio,
        persistencia,
        velocidad,
        cobertura,
        confianza
    });

    return {
        precision,
        dominio,
        persistencia,
        velocidad,
        cobertura,
        confianza
    };

};

const resolverIndice = (variables) => {

    const p =
        variables.precision *
        PESOS_INDICE.precision;

    const d =
        variables.dominio *
        PESOS_INDICE.dominio;

    const pe =
        variables.persistencia *
        PESOS_INDICE.persistencia;

    const v =
        variables.velocidad *
        PESOS_INDICE.velocidad;

    const c =
        variables.cobertura *
        PESOS_INDICE.cobertura;

    

    const indice =
        p + d + pe + v + c;

    console.log("INDICE");

    console.table({
        precision: p,
        dominio: d,
        persistencia: pe,
        velocidad: v,
        cobertura: c,
        indice
    });

    

    return indice;

};

const resolverNivel = (indice) => {

    return Math.max(

        0,

        Math.min(

            NIVEL_MAXIMO,

            Math.round(

                indice * NIVEL_MAXIMO

            )

        )

    );

};

const resolverDiagnostico = ({

    variables

}) => {

    const causas = [];

    if (variables.precision < 0.7) {

        causas.push("precision");

    }

    if (variables.dominio < 0.7) {

        causas.push("dominio");

    }

    return {

        causas,

        descripcion:

            causas.length === 0

                ? "Dominio suficiente."

                : "Existen variables que requieren fortalecimiento."

    };

};

/*======================================================
MODELO DE PROYECCIÓN
======================================================*/

const estimarPuntaje = ({

    estadoAcademico,

    examen = "UNAL"

}) => {

    const escala =

        ESCALAS_EXAMEN[examen];

    if (!escala) {

        throw new Error(

            `Escala no definida para ${examen}`

        );

    }

    const indice =

        Math.max(

            0,

            Math.min(

                1,

                estadoAcademico.indice

            )

        );

    const puntaje =

        escala.minimo +

        (

            indice *

            (

                escala.maximo -

                escala.minimo

            )

        );

        console.log("================================");
        console.log("ESTIMAR PUNTAJE");
        
        console.log("Examen:", examen);
        console.log("Estado recibido:");
        console.dir(estadoAcademico, { depth: null });
        
        console.log("Indice recibido:", estadoAcademico.indice);
        console.log("Indice normalizado:", indice);
        
        console.log("Escala:", escala);
        
        console.log("Puntaje calculado:", puntaje);
        console.log("Puntaje redondeado:", Math.round(puntaje));    

    return {

        examen,

        indice,

        puntaje:

            Math.round(

                puntaje

            ),

        escala

    };

};

const construirEstado = ({

    nodo,

    variables,

    indice,

    nivel,

    diagnostico

}) => {

    const estado = crearEstadoAcademico({

		tipo: nodo.tipo,
	
		id: nodo.id,
	
		hijos: nodo.hijos,
	
		variables,
	
		indice,
	
		nivel,
	
		suficiente:
	
			nivel >=
	
			(
	
				nodo.configuracion?.nivelObjetivo
	
				??
	
				3
	
			),
	
		diagnostico,
	
		metadata: {
	
			fechaResolucion: new Date(),
	
			versionMotor: "2.0"
	
		}
	
	});

    console.log("================================");
console.log("OBJETO ESTADO ANTES DE PROYECCIONES");

console.dir(estado, { depth: null });
	
	estado.proyecciones = {
	
		UNAL:
	
			estimarPuntaje({
	
				estadoAcademico: estado,
	
				examen: "UNAL"
	
			}),
	
		ICFES:
	
			estimarPuntaje({
	
				estadoAcademico: estado,
	
				examen: "ICFES"
	
			}),
	
		UDEA:
	
			estimarPuntaje({
	
				estadoAcademico: estado,
	
				examen: "UDEA"
	
			})
	
	};
	
    console.log("================================");
console.log("ESTADO FINAL");

console.log("INDICE:", indice);
console.log("NIVEL:", nivel);

console.table(variables);

console.log("PROYECCION UNAL");

console.dir(
    estado.proyecciones.UNAL,
    {
        depth: null
    }
);


	return estado;

};

/*======================================================
RESOLVER ESTADO ACADÉMICO
======================================================*/

const resolverEstadoAcademico = ({

    nodo,

    evidencias = [],

    fechaEvaluacion = new Date(),

    disponibilidad = {},

    configuracionMotor = {}

}) => {

    //--------------------------------------------------
    // 1. CREAR CONTEXTO
    //--------------------------------------------------

    let contexto = crearContextoResolucion({

        nodo,

        evidencias,

        fechaEvaluacion,

        disponibilidad,

        configuracionMotor

    });

    //--------------------------------------------------
// MODELO ACADÉMICO
//--------------------------------------------------

contexto.modeloAcademico = MODELO_ACADEMICO;

if (!contexto.modeloAcademico) {

    throw new Error(

        "MotorEvaluacion no ha sido inicializado."

    );

}

console.log("MODELO ACADEMICO");

console.log(

    contexto.modeloAcademico

);

const estadosTemas =

    construirEstadosTemas(contexto);

    const estadosComponentes =

    construirEstadosComponentes(

        contexto,

        estadosTemas

    );

console.log(

    "COMPONENTES"

);

console.log(

    estadosComponentes

);

console.log(

    "ESTADOS TEMAS"

);

Object.values(estadosTemas)

.forEach(t => {

    console.dir(t,{depth:null});

});

console.log(

    estadosTemas

);


Object.values(estadosComponentes)

    .forEach(

        resolverEstadoComponente

    );

console.log(

    "COMPONENTES EVALUADOS"

);

Object.values(estadosComponentes)

.forEach(c => {

    console.dir(c,{depth:null});

});

console.log(

    estadosComponentes

);

    //--------------------------------------------------
    // 2. RECUPERAR EVIDENCIAS
    //--------------------------------------------------

    contexto = recuperarEvidencias(contexto);

    //--------------------------------------------------
    // 3. VALIDAR ESTADO INICIAL
    //--------------------------------------------------

    contexto = validarEstadoInicial(contexto);

//--------------------------------------------------
// 4. EXAMEN
//--------------------------------------------------

const estadoExamen =

    resolverEstadoExamen(

        estadosComponentes

    );

    console.log("================================");
console.log("ESTADO EXAMEN COMPLETO");

console.dir(estadoExamen, {
    depth: null
});

const variables =

    estadoExamen.variables;

const indice =

    estadoExamen.indice;

const nivel =

    estadoExamen.nivel;
    //--------------------------------------------------
    // 7. DIAGNÓSTICO
    //--------------------------------------------------

    const diagnostico = resolverDiagnostico({

        variables,

        indice,

        nivel

    });

    //--------------------------------------------------
    // 8. ESTADO ACADÉMICO
    //--------------------------------------------------
    console.log("======================================");

    console.log("VARIABLES EXAMEN");
    
    console.table(variables);
    
    console.log("INDICE:",indice);
    
    console.log("NIVEL:",nivel);
    
    console.dir(estadoExamen,{
        depth:null
    });
    const estado = construirEstado({
        nodo,
        variables,
        indice,
        nivel,
        diagnostico
    });

    estado.desglose = construirDesglose(
        estadosTemas,
        estadosComponentes
    );

    return estado;

};


/*======================================================
MODELO ACADÉMICO
======================================================*/

let MODELO_ACADEMICO = null;

const cargarModeloAcademico = async () => {

    if (MODELO_ACADEMICO) {

        return MODELO_ACADEMICO;

    }

    const [

        examenesSnap,

        componentesSnap,

        temasSnap,

        temaComponenteSnap

    ] = await Promise.all([

        getDocs(collection(db, "examenes")),

        getDocs(collection(db, "componentes")),

        getDocs(collection(db, "materias_temas")),

        getDocs(collection(db, "tema_componente"))

    ]);

    MODELO_ACADEMICO = {

        examenes:

            examenesSnap.docs.map(doc => doc.data()),

        componentes:

            componentesSnap.docs.map(doc => doc.data()),

        temas:

            temasSnap.docs.map(doc => doc.data()),

        temaComponentes:

            temaComponenteSnap.docs.map(doc => doc.data())

    };

    return MODELO_ACADEMICO;

};

const inicializarMotor = async () => {

    await cargarModeloAcademico();

    console.log(

        "Motor de Evaluación inicializado."

    );

};

const agruparEvidenciasPorTema = (contexto) => {

    const mapa = {};

    contexto.evidencias.forEach(evidencia => {

        const temas = evidencia.temas ?? [];

        temas.forEach(idTema => {

            if (!mapa[idTema]) {

                mapa[idTema] = [];

            }

            mapa[idTema].push(evidencia);

        });

    });

    return mapa;

};

const construirEstadosTemas = (contexto) => {

    const estados = {};

    const evidenciasPorTema =

        agruparEvidenciasPorTema(contexto);

    contexto.modeloAcademico.temas.forEach(tema => {

        const idTema = tema.ID;

        const evidenciasTema =

    evidenciasPorTema[idTema] ?? [];

    console.log("=================================================");
console.log("TEMA", tema.ID, "-", tema.Nombre ?? "");
console.log("COMPONENTES DEL TEMA");

console.table(
    contexto.modeloAcademico.temaComponentes
        .filter(r => r.Tema === tema.ID)
);

const estadoTema = resolverVariablesTema(
    tema,
    evidenciasTema
);

estados[idTema] = {

    tema,

    evidencias: evidenciasTema,

    ...estadoTema

};

console.log("======================================");
console.log("ESTADO TEMA CONSTRUIDO");

console.log("ID Tema:", idTema);

console.dir(
    estados[idTema],
    { depth: null }
);

console.log(
    "Indice:",
    estados[idTema].indice
);

console.log(
    "Nivel:",
    estados[idTema].nivel
);

console.log(
    "Cantidad evidencias:",
    estados[idTema].evidencias.length
);

    });

    

    return estados;

};

const construirEstadosComponentes = (contexto, estadosTemas) => {

    const componentes = {};

    contexto.modeloAcademico.componentes.forEach(componente => {

        componentes[componente.ID] = {

            componente,

            temas: []

        };

    });

    console.log("======================================");
console.log("MODELO TEMA_COMPONENTE COMPLETO");

console.table(
    contexto.modeloAcademico.temaComponentes
);

console.log(
    "TOTAL RELACIONES:",
    contexto.modeloAcademico.temaComponentes.length
);

contexto.modeloAcademico.temaComponentes.forEach((relacion, index) => {

    console.log("======================================");
    console.log("RELACION", index + 1);

    console.dir(relacion, { depth: null });

    const idTema = relacion.TemaID;

    const estadoTema = estadosTemas[idTema];

    if (!estadoTema) {

        console.error(
            "NO EXISTE EL ESTADO DEL TEMA",
            idTema
        );

        return;

    }

    if (!Array.isArray(relacion.Componentes)) {

        console.error(
            "EL CAMPO Componentes NO ES UN ARRAY",
            relacion
        );

        return;

    }

    relacion.Componentes.forEach(idComponente => {

        const componente = componentes[idComponente];

        if (!componente) {

            console.error(
                "NO EXISTE EL COMPONENTE",
                idComponente
            );

            return;

        }

        componente.temas.push(estadoTema);

        console.log(
            "Tema",
            idTema,
            "agregado al componente",
            idComponente
        );

    });

});

console.log("======================================");
console.log("RESUMEN FINAL COMPONENTES");

Object.values(componentes).forEach(c => {

    console.log("--------------------------------");

    console.log(
        "COMPONENTE:",
        c.componente.ID
    );

    console.log(
        "TEMAS CARGADOS:",
        c.temas.length
    );

    console.log(
        "IDS:"
    );

    console.table(

        c.temas.map(t => ({

            tema: t.tema.ID,

            indice: t.indice,

            evidencias: t.evidencias.length

        }))

    );

});

console.log("========================================");
console.log("RESUMEN COMPONENTES");

Object.values(componentes).forEach(c => {

    console.log("--------------------------------");

    console.log(
        "COMPONENTE",
        c.componente.ID
    );

    console.log(
        "TEMAS:",
        c.temas.length
    );

    console.table(

        c.temas.map(t => ({

            tema: t.tema.ID,

            indice: t.indice,

            evidencias: t.evidencias.length

        }))

    );

});

    return componentes;

};



const resolverEstadoComponente = (componente) => {

    const temas = componente.temas;

    if (temas.length === 0) {

        componente.indice = 0;
        componente.nivel = 0;
        componente.variables = {};

        return componente;

    }

    const suma = temas.reduce(

        (total, tema) => total + tema.indice,

        0

    );

    componente.indice =

        suma / temas.length;

    componente.nivel =

        resolverNivel(componente.indice);

    componente.variables = {

        temasEvaluados:

            temas.filter(

                t => t.evidencias.length > 0

            ).length,

        totalTemas:

            temas.length

    };

    console.log("================================");
console.log("COMPONENTE", componente.componente.ID);

console.table(
    componente.temas.map(t => ({
        tema: t.tema.ID,
        evidencias: t.evidencias.length,
        indice: t.indice,
        nivel: t.nivel
    }))
);

console.log("INDICE COMPONENTE:", componente.indice);
console.log("NIVEL COMPONENTE:", componente.nivel);

    return componente;

};

const resolverEstadoExamen = (componentes) => {

    const lista = Object.values(componentes);

    if (lista.length === 0) {

        return {

            indice: 0,

            nivel: 0,

            variables: {}

        };

    }

    const suma = lista.reduce(

        (t, c) => t + c.indice,

        0

    );

    const indice =

        suma / lista.length;

        console.log("================================");
        console.log("ESTADO EXAMEN");
        
        lista.forEach(c => {
        
            console.log(
                "COMPONENTE",
                c.componente.ID,
                "INDICE",
                c.indice
            );
        
        });
        
        console.log("SUMA:", suma);
        console.log("TOTAL COMPONENTES:", lista.length);
        console.log("INDICE EXAMEN:", indice);
        console.log("NIVEL EXAMEN:", resolverNivel(indice));

    return {

        indice,

        nivel: resolverNivel(indice),

        variables: {

            componentes:

                lista.length

        }

    };

};

const resolverVariablesTema = (
    tema,
    evidencias = []
) => {

    console.log("================================");
    console.log("======================================");
console.log("TEMA:", tema.ID);
console.log("NOMBRE:", tema.Nombre);
console.log("OBJETIVO:", tema.NivelObjetivo);
console.log("PESO:", tema.Peso);
console.log("EVIDENCIAS");

console.table(
    evidencias.map(e => ({
        pregunta: e.preguntaId,
        resultado: e.resultado,
        dificultad: e.dificultad,
        tiempo: e.tiempoRespuesta,
        examen: e.examenes,
        temas: e.temas.join(",")
    }))
);
    console.log("Cantidad evidencias:", evidencias.length);
    console.table(evidencias);

    const contextoTema = {
        evidencias
    };

    const variables = resolverVariables(contextoTema);

    console.log("VARIABLES TEMA");
    console.table(variables);

    const indice = resolverIndice(variables);

    console.log("INDICE TEMA:", indice);

    const nivel = resolverNivel(indice);

    console.log("NIVEL TEMA:", nivel);

    return {
        variables,
        indice,
        nivel
    };

};

/*======================================================
DESGLOSE (aditivo: solo expone lo que el motor ya calculó)
======================================================*/

const construirDesglose = (estadosTemas, estadosComponentes) => {

    const temas = {};

    Object.entries(estadosTemas).forEach(([id, estado]) => {
        temas[id] = {
            id: estado.tema.ID,
            nombre: estado.tema.Tema ?? estado.tema.Nombre ?? `Tema ${estado.tema.ID}`,
            materia: estado.tema.Materia ?? "",
            macrotema: estado.tema.Macrotema ?? "",
            prerrequisitos: Array.isArray(estado.tema.Prerrequisitos)
                ? estado.tema.Prerrequisitos
                : [],
            indice: estado.indice,
            nivel: estado.nivel,
            variables: estado.variables,
            totalEvidencias: estado.evidencias.length
        };
    });

    const componentes = {};

    Object.entries(estadosComponentes).forEach(([id, estado]) => {
        componentes[id] = {
            id: estado.componente.ID,
            nombre: estado.componente.Componente ?? `Componente ${estado.componente.ID}`,
            examenId: estado.componente.ExamenID,
            indice: estado.indice ?? 0,
            nivel: estado.nivel ?? 0,
            temasEvaluados: estado.variables?.temasEvaluados ?? 0,
            totalTemas: estado.variables?.totalTemas ?? estado.temas.length,
            temas: estado.temas.map(t => t.tema.ID)
        };
    });

    return { temas, componentes };
};

const motorEvaluacion = {

    inicializarMotor,

    crearNodoAcademico,

    crearEstadoAcademico,

    resolverEstadoAcademico,

    estimarPuntaje

};


export default motorEvaluacion;
